<template>
  <div data-testid="tardy-csv-upload-container">
    <CContainer>
      <h1 class="sr-only">{{ $t("sidebar_items.tardy_csv_upload") }}</h1>
      <CRow class="justify-content-center mt-4">
        <CCol md="12 text-center">
          <TardyCsvUploadTable data-testid="tardy-csv-upload-table">
          </TardyCsvUploadTable>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import { onMounted } from "vue"
import { useI18n } from "vue-i18n"
import TardyCsvUploadTable from "@/v3components/Datatables/TardyCsvUploadTable.vue"

export default {
  name: "TardyCsvUpload",
  components: { TardyCsvUploadTable },
  setup() {
    const { t } = useI18n()

    onMounted(() => {
      document.title = `${t("sidebar_items.tardy_csv_upload")} · Securly Pass`
    })

    return {}
  }
}
</script>
